export default "__VITE_ASSET__Dwh1NGTt__"